import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Paper,
  Typography,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { fetchConToken } from "../../helpers/fetch";
import { 
    fetchGrupoFamiliarDestinoCambioTit, 
    fetchGrupoFamiliarOrigenCambioTit, 
    grupoFamiliarCambioTitularidadOrigenLimpiar,
    grupoFamiliarCambioTitularidadDestinoLimpiar 
} from "../../actions/grupoFamiliarCambioTitularidad";
import { BUSCADOR_CENTRAL } from "../../utils/constants";

export const BuscadorCambioTit = (props) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const cargando = open && options.length === 0;
  const [textoBuscado, setTextoBuscado] = useState("");
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    let typingTimer = null
    if (e.target.value.length >= BUSCADOR_CENTRAL.CARACTERES_MINIMOS_AFILIACIONES) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        setTextoBuscado(e.target.value);
      }, BUSCADOR_CENTRAL.MILISEG_SIN_CAMBIOS);
    }
  };

  const handleAfiliadoSeleccionado = (afiliado) => {
    if (!!afiliado) {
      if (!isNaN(afiliado?.id_afiliado)) {
        if(props.droppableId==='droppable')
          dispatch( fetchGrupoFamiliarOrigenCambioTit(afiliado?.id_afiliado) );
        else
          dispatch( fetchGrupoFamiliarDestinoCambioTit(afiliado?.id_afiliado) );
      }
    }
  };

  useEffect(() => {
    let active = true;

    (async () => {
      let texto = textoBuscado.replace("/", "__");
      if (texto.length > 0) {
        const response = await fetchConToken(
          `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${props.tipoBusqueda}/${props.altabaja}`
        );
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (active && lista.length > 0) {
            setOptions(
              Object.keys(lista).map((id_afiliado) => lista[id_afiliado])
            );
          }
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [textoBuscado, props.tipoBusqueda, props.altabaja]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    dispatch( grupoFamiliarCambioTitularidadOrigenLimpiar() );
    dispatch( grupoFamiliarCambioTitularidadDestinoLimpiar() );
  }, [dispatch]);

  const onInputChange = (e, value, reason) => {
      if(reason === 'clear'){
        if(props.droppableId==='droppable')
            dispatch( grupoFamiliarCambioTitularidadOrigenLimpiar() );
        else
            dispatch( grupoFamiliarCambioTitularidadDestinoLimpiar() );
      }
  }

  return (
    <>
        <Typography><strong>{props.title}</strong></Typography>
        <Paper component="form" style={{padding: '2px 4px', display: 'flex', alignItems: 'center', boxShadow: 'none' }}>
            <Autocomplete
                id="buscadorAfiliados"
                style={{
                width: 400,
                marginTop: 10,
                backgroundColor: "#FAFAFA",
                borderRadius: "5px",
                }}
                loadingText="Buscando..."
                open={open}
                onOpen={() => {
                setOpen(true);
                }}
                onClose={() => {
                setOpen(false);
                }}
                onInputChange={onInputChange}
                onChange={(event, newValue) => {
                handleAfiliadoSeleccionado(newValue);
                }}
                getOptionSelected={(option, value) =>
                option.id_afiliado === value.id_afiliado
                }
                getOptionLabel={(option) =>
                `${option.apellido_y_nombre} ${option.cuil}`
                }
                renderOption={(option) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span
                    style={
                        option.fecha_baja === null
                        ? { color: "green" }
                        : { color: "red" }
                    }
                    >
                    {`${option.apellido_y_nombre}`}
                    </span>
                    <span
                    style={{
                        fontSize: 12,
                    }}
                    >
                    {" "}
                    {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                    </span>
                </div>
                )}
                options={options}
                loading={cargando}
                renderInput={(params) => (
                <TextField
                    onChange={handleInputChange}
                    style={{
                    padding: 3,
                    }}
                    {...params}
                    label="Nombre | DNI | CUIL"
                    variant="outlined"
                    InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <>
                        {cargando ? (
                            <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                        </>
                    ),
                    }}
                />
                )}
            />
        </Paper>  
    </>
  );
};
